import React, { useEffect } from 'react';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { sellerProfilesSelectors } from 'Douleutaras/redux/data/seller/sellerProfilesSlice';
import { sellerProfilesCategoriesSelectors } from 'Douleutaras/redux/data/seller/sellerProfilesCategoriesSlice';
import QuickButton from 'Douleutaras/components/QuickButton/QuickButton';
import ModalSelectionItem from 'Douleutaras/components/modals/parts/ModalSelectionItem';

const CategoryButton = ({ id, buttonProps }) => {
  const category = useAppSelector(state => sellerProfilesCategoriesSelectors.selectById(state, id).attributes);

  // Don't list if not active, activated or availableForJon
  if (!category.activate || !category.activate || !category.availableForJob) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  return <QuickButton title={category.title} {...buttonProps} />;
};

interface CategoryStepProps {
  onSubmit({ categoryId }: { categoryId: string }): void;
}

const CategoryStep = ({ onSubmit }: CategoryStepProps) => {
  const profile = useAppSelector(state => sellerProfilesSelectors.selectAll(state)[0]);

  return <div>
    {profile?.relationships.autodealCategories.data.map(category =>
      <ModalSelectionItem  key={`category_key_${category.id}`}>
        <CategoryButton id={category.id}
                        buttonProps={{
                          onClick: () => onSubmit({ categoryId: category.id }),
                          selected: String(profile.attributes.lastConcludedCategoryForUser) === category.id
                        }}
        />
      </ModalSelectionItem>
    )}
  </div>;
};

export default CategoryStep;
